// product-page.js — variant selection, gallery thumbs, zoom, quantity
(function () {
  document.querySelectorAll('[id^="section-"].bc-pp').forEach((root) => {
    const section = root;
    const sectionId = section.id.replace('section-', '');
    const varKey = 'bcVariantsData_' + sectionId.replace(/-/g, '');
    const optKey = 'bcCurrentOptionsData_' + sectionId.replace(/-/g, '');
    const namesKey = 'bcOptionNamesData_' + sectionId.replace(/-/g, '');
    const urlKey = 'bcProductUrlData_' + sectionId.replace(/-/g, '');
    const variants = window[varKey] || [];
    const optionNames = window[namesKey] || [];
    const currentOptionValues = window[optKey] || [];
    const productUrl = window[urlKey] || '';

    const form = root.querySelector('#bc-product-form');
    if (!form) return;

    const variantIdInput = document.getElementById('bc-variant-id-' + sectionId);
    const priceEl = document.getElementById('bc-price-' + sectionId);
    const comparePriceEl = document.getElementById('bc-compare-price-' + sectionId);
    const stockEl = document.getElementById('bc-stock-' + sectionId);
    const addCartBtn = document.getElementById('bc-add-cart-' + sectionId);

    const selectedOptions = {};
    optionNames.forEach((name, i) => {
      selectedOptions[name] = currentOptionValues[i] != null ? currentOptionValues[i] : null;
    });

    function normalize(val) {
      return String(val == null ? '' : val).trim().replace(/\s+/g, ' ').toLowerCase();
    }

    function findVariant() {
      return variants.find((v) => {
        const vOpts = [v.option1, v.option2, v.option3];
        return optionNames.every((name, i) => normalize(vOpts[i]) === normalize(selectedOptions[name]));
      });
    }

    function money(cents) {
      const format = window.bcMoneyFormat || 'Rs.{{amount}}';
      const amount = (cents / 100).toFixed(2);
      const amountNoDecimals = Math.round(cents / 100).toString();
      const amountWithComma = amount.replace('.', ',');
      const amountNoDecimalsWithComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimalsWithComma)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    function updateUI() {
      const variant = findVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.innerHTML = money(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (stockEl) {
        stockEl.textContent = variant.available ? 'In Stock' : 'Sold Out';
        stockEl.classList.toggle('is-in-stock', variant.available);
        stockEl.classList.toggle('is-out-stock', !variant.available);
      }
      if (addCartBtn) {
        addCartBtn.disabled = !variant.available;
        addCartBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      if (variant.featured_media && variant.featured_media.preview_image) {
        const mainImg = document.getElementById('bc-main-image-' + sectionId);
        if (mainImg) mainImg.src = variant.featured_media.preview_image.src + '&width=1200';
      }

      if (productUrl && window.history && window.history.replaceState) {
        const newUrl = productUrl + '?variant=' + variant.id;
        window.history.replaceState({}, '', newUrl);
      }
    }

    root.querySelectorAll('[data-bc-option-value]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const wrapper = btn.closest('.bc-pp__option');
        const optionName = wrapper.dataset.optionName;
        wrapper.querySelectorAll('[data-bc-option-value]').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        const label = wrapper.querySelector('[data-bc-selected-value]');
        if (label) label.textContent = btn.dataset.bcOptionValue;
        selectedOptions[optionName] = btn.dataset.bcOptionValue;
        updateUI();
      });
    });

    root.querySelectorAll('[data-bc-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        root.querySelectorAll('[data-bc-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const mainImg = document.getElementById('bc-main-image-' + sectionId);
        if (mainImg) mainImg.src = thumb.dataset.fullSrc;
      });
    });

    // Zoom on click (desktop only — a tap on touch devices was
    // accidentally toggling zoom, making the image look over-zoomed on mobile)
    const mainImageWrap = root.querySelector('[data-bc-zoom]');
    const isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    if (mainImageWrap && !isTouchDevice) {
      mainImageWrap.addEventListener('click', () => {
        mainImageWrap.classList.toggle('is-zoomed');
      });
      mainImageWrap.addEventListener('mousemove', (e) => {
        if (!mainImageWrap.classList.contains('is-zoomed')) return;
        const rect = mainImageWrap.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        const img = mainImageWrap.querySelector('img');
        if (img) img.style.transformOrigin = x + '% ' + y + '%';
      });
    }

    const buyNowBtn = document.getElementById('bc-buy-now-' + sectionId);
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', () => {
        const variant = findVariant();
        if (!variant || !variant.available) return;
        const qty = document.getElementById('bc-qty-' + sectionId);
        const quantity = qty ? parseInt(qty.value, 10) || 1 : 1;
        buyNowBtn.disabled = true;
        const originalText = buyNowBtn.textContent;
        buyNowBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: quantity }] }),
        })
          .then((res) => {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(() => {
            window.location.href = '/checkout';
          })
          .catch((err) => {
            console.error('Buy now failed:', err);
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = originalText;
          });
      });
    }

    const qtyInput = document.getElementById('bc-qty-' + sectionId);
    const qtyMinus = root.querySelector('[data-bc-qty-minus]');
    const qtyPlus = root.querySelector('[data-bc-qty-plus]');
    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', () => {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }
  });
})();